export default function () {
  const icons = require.context('@/assets/icons/n-icon', true, /\.svg$/);
  const requireAll = (requireContext: any) => requireContext.keys().map(requireContext);
  requireAll(icons);
}
